import { render, staticRenderFns } from "./Publications.vue?vue&type=template&id=a14bb8c2&scoped=true"
import script from "./Publications.vue?vue&type=script&lang=js"
export * from "./Publications.vue?vue&type=script&lang=js"
import style0 from "./Publications.vue?vue&type=style&index=0&id=a14bb8c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14bb8c2",
  null
  
)

export default component.exports